// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XWXG","left":"styles_left__ZL02i"};